(() => {
  const storageKey = 'cart_token';
  const resumingForms = new WeakSet();
  const rootUrl = window.Shopify?.routes?.root || '/';
  const cartEndpoint = `${rootUrl}cart.js`;
  const isAppClipPage = /\/pages\/app-clip\/?$/.test(window.location.pathname);
  let pendingRequest = null;

  const saveToken = (cart) => {
    if (!cart?.token || Number(cart.item_count) <= 0) return null;

    const cleanToken = String(cart.token).split('?key=')[0];

    try {
      localStorage.setItem(storageKey, cleanToken);
      return cleanToken;
    } catch (error) {
      return null;
    }
  };

  const captureCartToken = () => {
    if (pendingRequest) return pendingRequest;

    pendingRequest = fetch(cartEndpoint, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then((response) => {
        if (!response.ok) throw new Error('Unable to read cart');
        return response.json();
      })
      .then(saveToken)
      .catch(() => null)
      .finally(() => {
        pendingRequest = null;
      });

    return pendingRequest;
  };

  const isCheckoutSubmission = (event) =>
    event.submitter?.matches('[name="checkout"], #checkout, #CartDrawer-Checkout') === true;

  const resumeCheckout = (form, submitter) => {
    resumingForms.add(form);

    try {
      form.requestSubmit(submitter || undefined);
    } catch (error) {
      resumingForms.delete(form);
      form.submit();
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    if (!isAppClipPage) captureCartToken();
  });

  window.addEventListener('pageshow', (event) => {
    if (event.persisted && !isAppClipPage) captureCartToken();
  });

  document.addEventListener('cart:change', (event) => {
    saveToken(event.detail?.cart);
  });

  document.addEventListener('cart:refresh', () => {
    if (!isAppClipPage) captureCartToken();
  });

  document.addEventListener('dialog:after-show', (event) => {
    if (event.target instanceof Element && event.target.matches('cart-drawer')) {
      captureCartToken();
    }
  });

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;

      if (!(form instanceof HTMLFormElement) || !isCheckoutSubmission(event)) return;

      if (resumingForms.has(form)) {
        resumingForms.delete(form);
        return;
      }

      event.preventDefault();
      const submitter = event.submitter;

      captureCartToken().finally(() => resumeCheckout(form, submitter));
    },
    true
  );
})();
